import React from "react";
import {Link} from "react-router-dom";

type SidebarDropDownFirstLevelMenuItemProps = {
    value: string;
    path: string;
};

const SidebarDropDownFirstLevelMenuItem: React.FC<SidebarDropDownFirstLevelMenuItemProps> = ({value, path}) => {
    return (
        <><Link to={path} onClick={() => {
            // localStorage.setItem("focus", value.toLowerCase())
        }} className={localStorage.getItem("focus") === value.toLowerCase() ?
            "px-3 py-2 rounded bg-blue-700 text-sm" :
            "px-3 py-2 rounded hover:bg-blue-700 text-sm"}>
            {value}
        </Link></>
    )
}

export default SidebarDropDownFirstLevelMenuItem;